import * as SharedMessageTypes from "../../../../darvin-shared/schema/zod/agent/message-types.schema";
import { isToolsMessage } from "../../../types/chatTypeGuards";
import {
  ProjectChatAssistantMessage,
  ProjectChatElement,
  ProjectChatTemporaryUserMessage,
  ProjectChatUserMessage,
} from "../../../view_stores/chat_messages/chatModels";
import { ProjectAssistantErrorMessage } from "./messages/assistant/ProjectAssistantErrorMessage";
import { ProjectAssistantUnifiedMessage } from "./messages/assistant/ProjectAssistantUnifiedMessage";
import { ProjectToolUsageMessage } from "./messages/ProjectToolUsageMessage";
import {
  ProjectUserMessage,
  RollbackBtnProps,
} from "./messages/ProjectUserMessage";

export const ProjectChatMessage = ({
  message,
  isLast,
  rollbackBtn,
}: {
  message: ProjectChatElement;
  isLast: boolean;
  rollbackBtn?: RollbackBtnProps;
}) => {
  const getComponent = () => {
    if (message instanceof ProjectChatUserMessage) {
      return (
        <ProjectUserMessage
          message={(message as ProjectChatUserMessage).value.message}
          attachments={
            (message as ProjectChatUserMessage).value.attachments ?? []
          }
          canBeAnimated={false}
          rollbackBtn={rollbackBtn}
        />
      );
    }

    if (message instanceof ProjectChatTemporaryUserMessage) {
      const attachedFile = (message as ProjectChatTemporaryUserMessage)
        .attachedFile;
      return (
        <ProjectUserMessage
          message={(message as ProjectChatTemporaryUserMessage).content}
          attachments={attachedFile ? [attachedFile] : []}
          canBeAnimated={true}
        />
      );
    }

    const assistantMsg = message as ProjectChatAssistantMessage;
    if (isToolsMessage(assistantMsg.value)) {
      return <ProjectToolUsageMessage message={assistantMsg} />;
    }

    if (assistantMsg.type === SharedMessageTypes.MessageTypeEnum.enum.error) {
      return (
        <ProjectAssistantErrorMessage message={assistantMsg} canFix={isLast} />
      );
    }

    return <ProjectAssistantUnifiedMessage message={assistantMsg} />;
  };

  return getComponent();
};
